export const getFilterOptionsForStudents = (data) => {
  let filterOptions = {} as any;

  if (data.countries?.length) {
    filterOptions.countries = data.countries
      .map((country) => country.code)
      .sort()
      .join();
  }

  if (data.students?.length) {
    filterOptions.studentIds = data.students
      .map((student) => student.id)
      .sort()
      .join();
  }

  return filterOptions;
};
